// Route guard for /users-roles. Only admin-capable realm roles may view the
// page; everyone else gets a clear access-denied state (defense-in-depth — the
// BFF also enforces the same roles on every endpoint).
import { Box, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useAuth } from "../../contexts/AuthContext";
import UsersRoles from "./index";

export const USERS_ADMIN_ROLES = [
  "platform_superadmin",
  "org_admin",
  "platform_admin",
  "admin",
];

const AccessDenied = () => (
  <Box sx={{ p: 3, maxWidth: 720, mx: "auto", textAlign: "center", mt: 8 }}>
    <LockOutlinedIcon sx={{ fontSize: 44, color: "var(--fx-text-secondary)", opacity: 0.5, mb: 1 }} />
    <Typography sx={{ fontSize: "1.0625rem", fontWeight: 700, color: "var(--fx-text-primary)", mb: 1 }}>
      Administrator access required
    </Typography>
    <Typography sx={{ fontSize: "0.8125rem", color: "var(--fx-text-secondary)", lineHeight: 1.6 }}>
      Managing platform members and roles requires an administrator role
      (<code>org_admin</code> or <code>platform_superadmin</code>). If you believe you should
      have access, contact your organization administrator.
    </Typography>
  </Box>
);

const UsersRolesGuarded = () => {
  const { hasRole } = useAuth();
  const allowed = USERS_ADMIN_ROLES.some((r) => hasRole?.(r));
  return allowed ? <UsersRoles /> : <AccessDenied />;
};

export default UsersRolesGuarded;
